




















































import {
  GetGroupsProductResponsePayload,
  GroupProduct
} from '@/store/modules/admin/types/group-product.types';
import { RootState } from '@/store/store';
import { IPaginationOptions } from 'nestjs-typeorm-paginate';
import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { Action, State } from 'vuex-class';
import CourseLicenseTemplateForm from './components/CourseLicenseTemplateForm.vue';
import {
  CourseLicenseTemplateReplacer,
  UpdateCourseLicenseTemplateApiDTO
} from '@/store/modules/jtms/course-license-template/course-license-template.types';
import {
  CourseLicenseTemplateResponse,
  CreateUpdateCourseLicenseTemplateApiDTO
} from '@/jbi-shared/dto/jtms.dtos';
import { ApiAxiosError, ApiState } from '@/store/types/general.types';
import { ToastProgrammatic } from 'buefy';

@Component({
  components: {
    CourseLicenseTemplateForm
  }
})
export default class CreateCourseLicenseTemplateModal extends Vue {
  @Prop({ default: false }) isEdit!: boolean;
  @Prop({ type: Object }) courseLicenseTemplate!: CourseLicenseTemplateResponse;

  name: string = '';
  selectedGroupProduct: GroupProduct | null = null;
  createCourseLicenseTemplateFormHasError: boolean = false;

  @Action('admin/getGroupProducts')
  getGroupProducts!: (
    options: IPaginationOptions
  ) => Promise<GetGroupsProductResponsePayload>;

  @Action('courseLicenseTemplate/createCourseLicenseTemplate')
  createCourseLicenseTemplate!: (
    options: CreateUpdateCourseLicenseTemplateApiDTO
  ) => void;

  @Action('courseLicenseTemplate/updateCourseLicenseTemplate')
  updateCourseLicenseTemplate!: (
    options: UpdateCourseLicenseTemplateApiDTO
  ) => void;

  @Action('courseLicenseTemplate/getAvailableReplacers')
  getAvailableReplacers!: () => void;

  @State((state: RootState) => state.courseLicenseTemplate.availableReplacers)
  availableReplacers!: CourseLicenseTemplateReplacer[];

  @State((state: RootState) => state.admin.groupProducts)
  groupProducts!: GetGroupsProductResponsePayload;

  @State(
    (state: RootState) =>
      state.courseLicenseTemplate.apiState.createCourseLicenseTemplate
  )
  createCourseLicenseTemplateApiState!: ApiState;

  @State(
    (state: RootState) =>
      state.courseLicenseTemplate.apiState.updateCourseLicenseTemplate
  )
  updateCourseLicenseTemplateApiState!: ApiState;

  created() {
    if (!this.groupProducts) {
      this.getGroupProducts({
        page: 1,
        // Use larger limit to retrieve all group products to prevent creating new API
        limit: Math.pow(10, 3)
      });
    }

    if (!this.availableReplacers) {
      this.getAvailableReplacers();
    }
  }

  mounted() {
    if (this.isEdit && this.courseLicenseTemplate && this.groupProducts) {
      this.name = this.courseLicenseTemplate.name;
      this.selectedGroupProduct = this.groupProducts.items.find(
        (gp) => gp.id === this.courseLicenseTemplate.groupProductId
      )!;
    }
  }

  processCreateNewCourseLicenseTemplate() {
    if (this.name && this.selectedGroupProduct) {
      const payload: CreateUpdateCourseLicenseTemplateApiDTO = {
        name: this.name,
        productId: this.selectedGroupProduct?.id!
      };

      this.createCourseLicenseTemplate(payload);
    }
  }

  processUpdateCourseLicenseTemplate() {
    if (this.name && this.selectedGroupProduct) {
      const payload: UpdateCourseLicenseTemplateApiDTO = {
        courseLicenseTemplateId: this.courseLicenseTemplate.id,
        name: this.name,
        productId: this.selectedGroupProduct?.id!
      };

      this.updateCourseLicenseTemplate(payload);
    }
  }

  updateErrorState(hasFieldError: boolean) {
    this.createCourseLicenseTemplateFormHasError = hasFieldError;
  }

  closeModal() {
    this.$emit('close');
  }

  triggerPageRefresh() {
    this.$emit('refreshPage');
  }

  @Watch('updateCourseLicenseTemplateApiState', { deep: true })
  onupdateCourseLicenseTemplateApiStateChanged(state: ApiState) {
    if (state.success) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-dark',
        position: 'is-top',
        message: `Course License Template successfully updated.`
      });

      this.closeModal();
      this.triggerPageRefresh();
    }

    if (state.error) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: String(
          (state.error as ApiAxiosError)?.response?.data?.message || state.error
        ),
        duration: 5000
      });
    }
  }

  @Watch('createCourseLicenseTemplateApiState', { deep: true })
  onCreateCourseLicenseTemplateApiStateChanged(state: ApiState) {
    if (state.success) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-dark',
        position: 'is-top',
        message: `Course License Template successfully created.`
      });

      this.closeModal();
      this.triggerPageRefresh();
    }

    if (state.error) {
      ToastProgrammatic.open({
        queue: true,
        type: 'is-danger',
        position: 'is-top',
        message: String(
          (state.error as ApiAxiosError)?.response?.data?.message || state.error
        ),
        duration: 5000
      });
    }
  }
}
